__turbopack_context__.v({
  "className": "inter_f98823b9-module__lfy5mW__className",
  "variable": "inter_f98823b9-module__lfy5mW__variable",
});
